import React, { Component, Fragment } from 'react'
// import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { CSSTransition } from 'react-css-transition'
import { Auth } from 'aws-amplify'
import * as Sentry from '@sentry/browser'
import Button from '../components/Button'
import Textbox from '../components/Textbox'
import TransitionStyles from '../lib/transitionStyles'
import ImportedMemberSignup from '../components/loginForm/ImportedMemberSignup'
import ForgotPassword from '../components/loginForm/ForgotPassword'
import Spinner from '../components/Spinner'

class LoginForm extends Component {

  constructor(props) {
    super(props)
    this.state = {
      email: "",
      password: "",
      showValidationError: false,
      isAuthenticated: false,
      isAuthenticating: true
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleLogout = this.handleLogout.bind(this)
    this.showImportedMemberSignup = this.showImportedMemberSignup.bind(this)
    this.showForgotPassword = this.showForgotPassword.bind(this)
    this.afterLoginAction = props.afterLoginAction.bind(this)
    this.afterSignupAction = this.afterSignupAction.bind(this)
    this.afterForgotPasswordAction = this.afterForgotPasswordAction.bind(this)
  }

  async componentDidMount() {
    try {
      if (await Auth.currentSession()) {
        this.setState({ isAuthenticated: true })
      }
    }
    catch (e) {
      if (e !== 'No current user') {
        alert(e)
      }
    }

    this.setState({ isAuthenticating: false })
  }

  handleChange(event) {
    let { value } = event.target
    if (event.target.id === 'email') {
      value = value.toLowerCase()
    }
    this.setState({
      [event.target.id]: value
    })
  }

  async handleSubmit(event) {
    event.preventDefault()
    try {
      const { email, password } = this.state
      this.setState({ isAuthenticating: true })
      await Auth.signIn(email, password)
      this.setState({ isAuthenticated: true, isAuthenticating: false })

      Sentry.configureScope((scope) => {
        scope.setUser({ email });
      });

      // if (window.Autopilot) {
      //   window.Autopilot.run("associate", {
      //     Email: email
      //   })
      // }
       
      this.afterLoginAction()
    } catch (e) {
      this.setState({
        isAuthenticating: false,
        showValidationError: true
      })
      console.log('Error', e.message)
    }
  }

  showImportedMemberSignup() {
    this.setState({ showImportedMemberSignup: true })
  }

  showForgotPassword() {
    this.setState({ showForgotPassword: true })
  }

  async handleLogout(event) {
    event.preventDefault()
    await Auth.signOut()
    this.setState({ isAuthenticated: false })
  }

  afterSignupAction(email, password) {
    this.setState({ showImportedMemberSignup: false, email, password })
  }

  afterForgotPasswordAction(email, password) {
    this.setState({ showForgotPassword: false, email, password })
  }

  render() {
    const { email, password, isAuthenticating, isAuthenticated, showValidationError, showImportedMemberSignup, showForgotPassword } = this.state

    if (showImportedMemberSignup) {
      return (
        <CSSTransition {...TransitionStyles} transitionAppear active>
          <ImportedMemberSignup afterSignupAction={this.afterSignupAction} />
        </CSSTransition>
      )
    }

    if (showForgotPassword) {
      return (
        <CSSTransition {...TransitionStyles} transitionAppear active>
          <ForgotPassword afterForgotPasswordAction={this.afterForgotPasswordAction} />
        </CSSTransition>
      )
    }    

    if (isAuthenticated) {
      return (
        <div className="flex flex-row">
          <div className="flex-grow">
            <FormattedMessage
              id="login.isLoggedIn"
              defaultMessage="You are logged in"
            />
          </div>
          <Button onClick={this.handleLogout}>
            <Fragment>Log out</Fragment>
          </Button>
        </div>
      )
    }

    return (
      <div>
        <h1>
          <FormattedMessage
            id="login.title"
            defaultMessage="Login"
          />
        </h1>

        {/* <CSSTransition {...TransitionStyles} transitionAppear active>
          <div className="flex items-center bg-sky-80 text-white text-sm px-4 py-4 my-8">
            <svg className="fill-current w-6 h-6 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" /></svg>
            <div>
              <p>
                <strong>
                  <FormattedMessage id="login.announcement.note" defaultMessage="NB:" />
                </strong>
                &nbsp;
                <FormattedMessage
                  id="login.announcement.text"
                  defaultMessage="If you are a member but don't have a password yet {link}"
                  values={{
                    link: (
                      <button
                        onClick={this.showImportedMemberSignup}
                        className="font-bold text-harbor underline focus:outline-none"
                        type="button"
                      >
                        <FormattedMessage id="login.announcement.link" defaultMessage="activate your profile and create password" />
                      </button>
                    )
                  }}
                />
              </p>
            </div>
          </div>
        </CSSTransition> */}

        <form onSubmit={this.handleSubmit}>
          <div className="mt-4">
            <h3>
              <FormattedMessage id="login.form.header" defaultMessage="Login using password" />
            </h3>
            <label
              htmlFor="email"
              className="text-sky text-sm font-bold"
            >
              <FormattedMessage id="login.email.label" defaultMessage="E-mail (the one you used when signing up)" />
              
              <div>
                <Textbox
                  htmlId="email"
                  htmlName="email"
                  type="email"
                  value={email}
                  onChange={this.handleChange}
                  className="w-64"
                  // className="w-full md:w-1/2"
                />
              </div>
            </label>
          </div>

          <div className="mt-4">
            <label
              htmlFor="password"
              className="text-sky text-sm font-bold"
            >
              <FormattedMessage id="login.password.label" defaultMessage="Password" />
              <div>
                <Textbox
                  htmlId="password"
                  htmlName="password"
                  value={password}
                  onChange={this.handleChange}
                  type="password"
                  className="w-64"
                  // className="w-full md:w-1/2"
                />
              </div>
            </label>
          </div>

          <div className="mt-4">
            <button
              onClick={this.showForgotPassword}
              className="underline"
              type="button"
            >
              <FormattedMessage id="login.forgotpass.link" defaultMessage="Forgot password?" />
            </button>
          </div>

          {showValidationError && (
            <CSSTransition {...TransitionStyles} transitionAppear active>
              <div className="text-sm mt-4 bg-red-lightest border-l-2 border-red text-red-dark p-2" role="alert">
                <p className="font-bold m-0">
                  <FormattedMessage id="login.error.title" defaultMessage="Wrong username or password" />
                </p>
                <p className="m-0">
                  <FormattedMessage id="login.error.text" defaultMessage="We can&apos;t find your username - or your password is not correct" />
                </p>
              </div>
            </CSSTransition>
          )}

          <div className="mt-4 flex flex-row justify-end">
            {isAuthenticating ? (
              <div className="text-grey">
                <Spinner type="compact" />
              </div>
            ) : (
              <Button>
                <FormattedMessage
                  id="login.submit"
                  defaultMessage="Login"
                />
              </Button>
              )}
          </div>
        </form>
      </div>
    )

  }
}

LoginForm.propTypes = {
  afterLoginAction: PropTypes.func
}

LoginForm.defaultProps = {
  afterLoginAction: () => { }
}

export default LoginForm
